<template>
  <div class="module_header">
    <div class="header_under">
      <span></span>
      <div class="line">
        <li>///////////////////////////////////////////////////////////////</li>
        <li>///////////////////////////////////////////////////////////////</li>
      </div>
    </div>
    <div class="header_above">
      <div class="biaoqian">{{ chineseTitle }}</div>
      <div class="biaoqian_eng">{{ englishTitle }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModuleHeader",
  props: {
    chineseTitle: {
      type: String,
      required: true,
      default: "",
    },
    englishTitle: {
      type: String,
      required: true,
      default: "",
    },
  },
};
</script>

<style scoped lang="scss">
li {
  text-decoration: none;
  list-style: none;
}
.module_header {
  position: relative;
  width: 100%;
  .header_under {
    display: flex;
    flex-direction: column;
    span {
      width: 100%;
      height: 2px;
      background: rgba(0, 0, 0, 1);
    }
    .line {
      margin-top: 5px;
      display: flex;
      justify-content: space-between;
      width: 100%;
      font-family: SourceHanSansCN, SourceHanSansCN;
      font-weight: 400;
      font-size: 16px;
      color: #ffe0ab;
    }
  }
  .header_above {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    .biaoqian {
      background: url("../assets/biaoqian.png") no-repeat center center;
      background-size: 100% 100%;
      padding: 0 42px;
      box-sizing: border-box;
      font-family: SourceHanSansCN, SourceHanSansCN;
      font-weight: 400;
      font-size: 42px;
      color: #fff;
      text-align: center;
      height: 66px;
      line-height: 66px;
      display: inline-block;
      white-space: nowrap;
      width: fit-content;
      min-width: fit-content;
    }
    .biaoqian_eng {
      font-family: SourceHanSansCN, SourceHanSansCN;
      font-weight: 400;
      font-size: 30px;
      color: #000000;
      text-align: center;
      margin-top: 8px;
      width: fit-content;
    }
  }
}

// 平板端响应式 (768px - 1024px)
@media screen and (max-width: 1024px) and (min-width: 768px) {
  .module_header {
    .header_under {
      .line {
        font-size: 14px;
      }
    }
    .header_above {
      .biaoqian {
        font-size: 32px;
        padding: 0 32px;
        height: 50px;
        line-height: 50px;
      }
      .biaoqian_eng {
        font-size: 24px;
        margin-top: 6px;
      }
    }
  }
}

// 移动端响应式 (< 768px)
@media screen and (max-width: 767px) {
  .module_header {
    .header_under {
      .line {
        font-size: 12px;
        margin-top: 3px;

        li {
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
    .header_above {
      .biaoqian {
        font-size: 24px;
        padding: 0 20px;
        height: 40px;
        line-height: 40px;
      }
      .biaoqian_eng {
        font-size: 18px;
        margin-top: 5px;
      }
    }
  }
}
</style>
